import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import './IncentiveDescription.css'
import { FaXRay, FaBrain, FaAtom } from 'react-icons/fa'

function IncentiveDescription() {
  const navigate = useNavigate()

  return (
    <div className="incentive-container">
      <div className="incentive-header">
        <div className="back-button">
          <Button 
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            type="text"
            size="large"
            className="go-back-btn"
          >
            Go Back
          </Button>
        </div>
        <div className="header-content">
          <h1>Incentive Calculator</h1>
          <div className="header-underline"></div>
          <p className="subtitle">Understanding Your Rewards Structure</p>
        </div>
      </div>

      <div className="cards-container">
        {/* X-Ray Card */}
        <div className="incentive-card">
          <div className="card-header xray">
            <div className="icon-wrapper">
              <FaXRay className="modality-icon" />
            </div>
            <h2>X-Ray (XRAY)</h2>
          </div>
          <div className="card-content">
            <div className="incentive-row">
              <div className="amount-badge">₹3</div>
              <div className="condition">
                <span className="condition-label">Base Rate</span>
                <span className="condition-text">No discount applied</span>
              </div>
            </div>
            <div className="incentive-row">
              <div className="amount-badge">₹2</div>
              <div className="condition">
                <span className="condition-label">Mid Tier</span>
                <span className="condition-text">0% - 50% discount</span>
              </div>
            </div>
            <div className="incentive-row">
              <div className="amount-badge">₹1</div>
              <div className="condition">
                <span className="condition-label">Base Tier</span>
                <span className="condition-text">&gt; 50% discount</span>
              </div>
            </div>
          </div>
        </div>

        {/* CT/MRI Card */}
        <div className="incentive-card">
          <div className="card-header ct-mri">
            <div className="icon-wrapper">
              <FaBrain className="modality-icon" />
            </div>
            <h2>CT/MRI</h2>
          </div>
          <div className="card-content">
            <div className="incentive-row">
              <div className="amount-badge premium">₹10</div>
              <div className="condition">
                <span className="condition-label">Premium</span>
                <span className="condition-text">No discount applied</span>
              </div>
            </div>
            <div className="incentive-row">
              <div className="amount-badge">₹7.5</div>
              <div className="condition">
                <span className="condition-label">High Tier</span>
                <span className="condition-text">0% - 20% discount</span>
              </div>
            </div>
            <div className="incentive-row">
              <div className="amount-badge">₹5</div>
              <div className="condition">
                <span className="condition-label">Mid Tier</span>
                <span className="condition-text">20% - 40% discount</span>
              </div>
            </div>
            <div className="incentive-row">
              <div className="amount-badge">₹2.5</div>
              <div className="condition">
                <span className="condition-label">Base Tier</span>
                <span className="condition-text">&gt; 40% discount</span>
              </div>
            </div>
          </div>
        </div>

        {/* NM Card */}
        <div className="incentive-card">
          <div className="card-header nm">
            <div className="icon-wrapper">
              <FaAtom className="modality-icon" />
            </div>
            <h2>Nuclear Medicine</h2>
          </div>
          <div className="card-content">
            <div className="incentive-row">
              <div className="amount-badge premium">₹75</div>
              <div className="condition">
                <span className="condition-label">Premium</span>
                <span className="condition-text">No discount applied</span>
              </div>
            </div>
            <div className="incentive-row">
              <div className="amount-badge">₹50</div>
              <div className="condition">
                <span className="condition-label">High Tier</span>
                <span className="condition-text">0% - 25% discount</span>
              </div>
            </div>
            <div className="incentive-row">
              <div className="amount-badge">₹25</div>
              <div className="condition">
                <span className="condition-label">Mid Tier</span>
                <span className="condition-text">25% - 40% discount</span>
              </div>
            </div>
            <div className="incentive-row">
              <div className="amount-badge">₹10</div>
              <div className="condition">
                <span className="condition-label">Base Tier</span>
                <span className="condition-text">&gt; 40% discount</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Formula Section */}
      <div className="formula-section">
        <div className="section-header">
          <h2>Discount Calculation</h2>
          <div className="section-underline"></div>
        </div>
        <div className="formula-box">
          <div className="formula-content">
            <code>Discount % = ((Standard Price - Client Price) / Standard Price) × 100</code>
          </div>
        </div>
      </div>

      {/* Multi-Study Section */}
      <div className="multi-study-section">
        <div className="section-header">
          <h2>Multi-Study Cases</h2>
          <div className="section-underline"></div>
        </div>
        <div className="info-box">
          <div className="info-content">
            <p>For cases with multiple studies:</p>
            <ul>
              <li>Each study's incentive is calculated individually</li>
              <li>The highest incentive amount is awarded</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IncentiveDescription
